import { useContactsHead } from '~/domains/contacts/queries/useContactHead'
import { parseIdList } from '~/utils/lists'
import { formatName } from '~/utils/names'
import { chipValueMore } from '../FilterBar.css'

export const ContactsChipValue = ({ value }: { value: string }) => {
  const heads = useContactsHead({ contactIds: parseIdList(value) })
  const contacts = heads.flatMap(({ data }) => (data ? [data] : []))
  const first = contacts[0]
  if (!first) {
    return null
  }
  return (
    <>
      {formatName(first)}{' '}
      {contacts.length > 1 && (
        <span className={chipValueMore}>+{contacts.length - 1}</span>
      )}
    </>
  )
}
